"use client"

import { motion } from "framer-motion"
import { Check, ChevronRight, User2 } from 'lucide-react'
import { useEffect, useState } from 'react'

const features = [
  "Specialty Chemicals Distribution",
  "Advanced Polyurethane Solutions",
  "Aluminium Surface Treatment Expertise",
  "Plastics and Polymers Products"
]

const stats = [
  { value: 0, label: "Customer satisfaction", suffix: "%" },
  { value: 0, label: "Worldwide Users" },
  { value: 0, label: "Chemical Decisions Made", suffix: "%" },
  {
    value: 0, label: "Tasks completed"
  }
]

function Counter({ value, suffix }) {
  const [count, setCount] = useState(0)

  useEffect(() => {
    let start = 0
    const end = value
    const duration = 2000
    const increment = end / (duration / 16)

    const timer = setInterval(() => {
      start += increment
      if (start > end) {
        setCount(end)
        clearInterval(timer)
      } else {
        setCount(Math.floor(start))
      }
    }, 16)

    return () => clearInterval(timer)
  }, [value])

  return <span>{count}{suffix}</span>
}

export function AboutUser() {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 md:mb-16 flex justify-center items-center flex-col">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-blue-600 font-medium block mb-4"
          >
            Who We Are
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="text-4xl md:text-5xl font-bold leading-none"
          >
            Industry Leadership
          </motion.h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="/images/diverse_industries.avif"
                alt="Medical Professional"
                className="object-cover w-full h-full"
              />
            </div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="absolute -bottom-6 left-6 bg-white rounded-xl shadow-lg p-4 flex items-center gap-3"
            >
              <div className="bg-blue-600 rounded-full p-2">
                <User2 className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="font-medium text-sm">Our Vision</p>
                <p className="text-sm text-gray-600">Solution</p>
              </div>
            </motion.div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-4xl md:text-5xl font-bold leading-tight text-[#0B2A4A]"
            >
              Serving Diverse
              <br />
              Industries with Excellence
            </motion.h2>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="text-gray-600"
            >
              Interpetro Chemicals Trading FZ-LLC is a trusted multinational organization specializing in industrial chemicals. With our headquarters in RAK-UAE, we have an extensive operational footprint across Africa, the Middle East, the Subcontinent, and Southeast Asia.
            </motion.p>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="grid grid-cols-2 gap-4"
            >
              {features.map((feature, index) => (
                <motion.div
                  key={feature}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.5 + index * 0.1 }}
                  className="flex items-center gap-2 bg-gray-50 rounded-lg p-3"
                >
                  <div className="bg-blue-600 rounded-full p-1">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="font-medium">{feature}</span>
                </motion.div>
              ))}
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <button
                className="group bg-blue-600 hover:bg-blue-700 text-white py-3 px-8 rounded-full flex items-center"
              >
                More About Us
                <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </button>
            </motion.div>
          </motion.div>
        </div>
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9 + index * 0.1 }}
              className="text-center"
            >
              <div className="text-3xl md:text-4xl font-bold text-[#0B2A4A] mb-2">
                <Counter value={stat.value} suffix={stat.suffix} />
              </div>
              <p className="text-gray-600 text-sm">{stat.label}</p>
            </motion.div>
          ))}
        </motion.div> */}
      </div>
    </section>
  )
}

